<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.42455 14.3076C5.16953 14.0681 5.16967 13.6797 5.42487 13.44L13.645 5.71999C13.9002 5.48033 14.3138 5.4802 14.5689 5.7197C14.8239 5.9592 14.8237 6.34765 14.5686 6.58731L6.34837 14.3073C6.09318 14.547 5.67957 14.5471 5.42455 14.3076Z"
      :fill="color"
    />
    <path
      d="M14.1231 13.6182C13.7624 13.6183 13.47 13.3437 13.4701 13.0049L13.4726 6.13784C13.4727 5.79901 13.7653 5.52425 14.1261 5.52413C14.4868 5.52402 14.7792 5.7986 14.7791 6.13742L14.7766 13.0045C14.7765 13.3433 14.4839 13.618 14.1231 13.6182Z"
      :fill="color"
    />
    <path
      d="M6.14093 6.13397C6.14106 5.79515 6.43362 5.52038 6.79439 5.52027L14.1063 5.51794C14.4671 5.51783 14.7595 5.7924 14.7594 6.13123C14.7592 6.47005 14.4667 6.74481 14.1059 6.74493L6.79395 6.74725C6.43318 6.74737 6.14081 6.47279 6.14093 6.13397Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconArrowLink",
  props: {
    color: {
      default: "currentColor",
    },
  },
};
</script>

<style scoped></style>
